import React from 'react'

const PrivacyCustomHeading = ({ text, myClass }) => {
  return (
    <h2
      className={`text-[30px] font-bold leading-[134%] text-[#010101] max-md:text-2xl ${myClass}`}
    >
      {text}
    </h2>
  );
};

export default PrivacyCustomHeading